<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Produits / services issus du catalogue') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
            </div>
        </div>

        <el-table ref="multipleTable" :data="rows" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column property="name" :label="$t.__('common.labels.reference')">
            </el-table-column>
            <el-table-column
                :label="$t.__('documents.overview.tab.margin.unit_purchase_amount_exclude_tax')"
            >
                <template #default="scope">
                    {{
                        $filters.numberFormatWithOptions(
                            scope.row.purchaseAmount,
                            unitNumberFormat,
                            true,
                        )
                    }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.quantity')">
                <template #default="scope">
                    {{ $filters.numberFormat(scope.row.qt) }}
                </template>
            </el-table-column>
            <el-table-column
                :label="
                    $t.__('documents.overview.tab.margin.Custom.total_purchase_amount_exclude_tax')
                "
            >
                <template #default="scope">
                    {{
                        $filters.numberFormatWithOptions(
                            scope.row.totalPurchaseAmount,
                            docNumberFormat,
                            true,
                        )
                    }}
                </template>
            </el-table-column>
        </el-table>

        <div v-if="rows.length > 0" class="aright fs-3 mt-2">
            {{ $l10n.__('Total impact') }} :
            {{ $filters.numberFormatWithOptions(formattedTotal, docNumberFormat, true) }}
        </div>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data() {
        return {
            context: 'item',
        };
    },
    computed: {
        formattedTotal: function () {
            if (this.original.length == 0) {
                return 0;
            }
            return this.original.reduce((accumulator, row) => {
                return accumulator + parseFloat(row.totalPurchaseAmount);
            }, 0);
        },
        ...mapState({
            rows: (state) => state.rows,
            original: (state) => state.rows.filter((link) => link.processMargin === true),
        }),
    },
};
</script>
